import type { CheckoutQuote } from "@pufimi/shared";

// Money formatting for the checkout summary (#228). Kept ICU-free and pure so
// the output is deterministic across environments (Intl currency output drifts
// with the platform's ICU version) and unit-testable without a DOM. The price
// is stored in integer minor units (cents/grosze); we render major units with
// two fraction digits and the currency code after a space — e.g. `129,00 PLN`.
// PL uses a comma decimal separator, so we swap the dot.
export function formatPriceCents(cents: number, currency: string): string {
  const major = (cents / 100).toFixed(2).replace(".", ",");
  return `${major} ${currency}`;
}

// The złoty-symbol form ("30,00 zł" rather than the ISO "30,00 PLN"), for the
// consumer-facing preview slider's tier delta (#228) where the short symbol reads
// better. PLN only (the MVP is PL-only); same comma decimal + two fraction digits.
export function formatPriceZl(cents: number): string {
  return `${(cents / 100).toFixed(2).replace(".", ",")} zł`;
}

// Convenience for a whole quote — the summary always renders `unitPriceCents`
// times quantity 1 today, so this is the line total too.
export function formatQuotePrice(
  quote: Pick<CheckoutQuote, "unitPriceCents" | "currency">,
): string {
  return formatPriceCents(quote.unitPriceCents, quote.currency);
}
